import type {
  DocumentSchema,
  SearchParamsWithPreset,
} from 'typesense/lib/Typesense/Documents';
import type { SearchParams } from 'typesense/lib/Typesense/Types';
import { AUTO_CAROUSEL_DEFAULT_RESULTS_PER_PAGE } from './automated-carousels';
import type { SetlistContext } from './client';

export interface GetCarouselsForSlugParams {
  searchParameters?:
    | SearchParams<DocumentSchema, string>
    | SearchParamsWithPreset<DocumentSchema, string>;
}

export interface MultiSearchQueryBuilderProps {
  collection: string;
  filter_by?: string;
  per_page: number;
  q?: string;
  query_by?: string | string[];
  sort_by?: string | string[];
}

export const getCarousels = async (
  context: SetlistContext,
  params?: GetCarouselsForSlugParams
) => {
  const { searchParameters } = params || {};

  const response = await context.client
    .collections('carousels')
    .documents()
    .search(
      {
        q: '"music"',
        query_by: 'page_slug',
        per_page: 250,
        sort_by: 'order:asc',
        filter_by: 'page_slug:="music"',
        ...searchParameters,
      },
      {
        cacheSearchResultsForSeconds: 0,
      }
    );

  return response;
};

export const getCarouselsMulti = async (
  context: SetlistContext,
  pageCarouselParams?:
    | SearchParams<DocumentSchema, string>
    | SearchParamsWithPreset<DocumentSchema, string>,
  autoCarouselParams?:
    | SearchParams<DocumentSchema, string>
    | SearchParamsWithPreset<DocumentSchema, string>
) => {
  const searches: MultiSearchQueryBuilderProps[] = [
    {
      collection: 'carousels',
      q: '"music"',
      query_by: 'page_slug',
      per_page: 250,
      sort_by: 'order:asc',
      filter_by: 'page_slug:="music"',
      ...pageCarouselParams,
    },
  ];

  if (autoCarouselParams?.q !== '') {
    searches.push({
      collection: 'carouselsAuto.v1',
      per_page: AUTO_CAROUSEL_DEFAULT_RESULTS_PER_PAGE,
      ...autoCarouselParams,
    });
  }

  const response = await context.client.multiSearch.perform(
    {
      searches,
    },
    { use_cache: true }
  );

  return response;
};
